exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* #page-user-list {\r\n  .user-list-filters {\r\n    .vs__actions {\r\n      position: absolute;\r\n      right: 0;\r\n      top: 50%;\r\n      transform: translateY(-58%);\r\n    }\r\n  }\r\n} */\n.con-vs-popup[data-v-b370d44a] .vs-popup {\n  width: 1000px !important;\n  height: 600px !important;\n}\r\n", ""]);

// exports
